import styles from './StudySettingsEssentials.scss';
import { PageTitle } from 'components/common/Study/PageComponents';
import CopyLink from 'components/common/CopyLink/CopyLink';
import { connect } from 'react-redux';
import MultiSelect from 'components/common/MultiSelectCheckbox/BinderV4Field';
import { datasourceOverrider, getOverride, getStudyDetailFromOverride } from 'common/util/binderHelpers';
import { filter, get, isArray, isEmpty, map } from 'lodash';
import { manageStudyMetadataPredicate } from 'common/permissions/studyPredicates';
import DocumentDrivingDetailIcon from 'components/common/DocumentDrivingDetailIcon/index';
import FlatInput from 'components/common/Input/FlatInput';
import Select from 'react-select';
import InputField from 'components/common/Study/InputField/index';
import ChevronIcon from 'components/common/ChevronFaIcon';
import { customStylesV2 } from 'components/common/Dropdown/DropDownListHelper';
import { useState, useEffect, Fragment } from 'react';
import SaveFixedFooter from 'pages/studyOverview/components/SaveFixedFooter';
import { updateStudy, recordBinderBillableHistory } from 'pages/studyOverview/actions/study';
import ErrorMessage from 'components/common/ErrorMessage';
import LoadingComponent from 'common/permissions/components/LoadingComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faDollarSign } from '@fortawesome/free-solid-svg-icons';

const SPONSOR = {
    label: 'Sponsor',
    name: 'sponsorCro',
    binderLevelSelector: 'sponsorCro'
};

const TRIAL_ID = {
    label: 'Protocol Number / Trial id',
    name: 'trialId',
    binderLevelSelector: 'trialId'
};

const BILLABE_TEMPLATE_MESSAGE = 'Notice: Setting the Study Stage to _stage_ will send all Pending DOA signature requests and set the Binder to Billable. This action is irreversible.';
const NON_BILLABLE_TEMPLATE_MESSAGE = 'Notice: Setting the Study Stage to _stage_ will send all Pending DOA signature requests. This action is irreversible.';

const billbleLifeCycleStages = ['Open to Accrual', 'Maintenance'];

function BasicInformation({
    delegationOfAuthorityEnabled,
    eventsTabEnabled,
    createdByUser,
    id,
    metadata,
    currentStage,
    studyStages,
    name,
    dataSources,
    selectedDatasourceOverrides,
    canAddDataSource,
    canManageStudyMetadata,
    studyDetails,
    binder,
    institutionId,
    studyType,
    updateStudy,
    binderDescriptors,
    isMissingDetail,
    isStudyBinder,
    binderTemplates,
    recordBinderBillableHistory,
    ...props
}) {
    const [currentStageValue, setCurrentStageValue] = useState(currentStage);
    const [eventsTabEnable, setEventsEnabled] = useState(eventsTabEnabled);
    const [doaEnabled, setDoaEnabled] = useState(delegationOfAuthorityEnabled);
    const [studyName, setStudyName] = useState(name);
    const [selectAllOnLoad, setSelectAllOnLoad] = useState(false);
    const [listNode, setListNode] = useState('');
    const [currentDetails, setCurrentDetails] = useState({
        sponsorCro: '',
        trialId: ''
    });
    const [updateDetails, setUpdatedDetails] = useState({
        sponsorCro: '',
        trialId: ''
    });
    const [isUpdated, setIsUpdated] = useState({
        sponsorCro: '',
        trialId: ''
    });

    const [sponsorValue, setSponsorValue] = useState();
    const [trialValue, setTrialValue] = useState();
    const [isDetailEmpty, setIsDetailEmpty] = useState({
        sponsorCro: false,
        trialId: false,
        binderName: false,
    });

    const [sponsor, setSponsor] = useState({});
    const [protocol, setProtocol] = useState({});
    const [studyStageChangeWaningMessage, setStudyStageChangeWaningMessage] = useState({
        billable: false,
        message: ''
    });

    useEffect(() => {
        if (studyDetails.length && selectedDatasourceOverrides && dataSources.length) {
            setProtocol(getStudyDetailFromOverride(TRIAL_ID.label, selectedDatasourceOverrides, dataSources, studyDetails));
            setSponsor(getStudyDetailFromOverride(SPONSOR.label, selectedDatasourceOverrides, dataSources, studyDetails));
        }

    }, [studyDetails, selectedDatasourceOverrides, dataSources]);

    useEffect(() => {        
        if (!isEmpty(sponsor)) {
            setSponsorValue(getValue(SPONSOR));
        }
    }, [sponsor, metadata]);
    
    useEffect(() => {        
        if (!isEmpty(protocol)) {
            setTrialValue(getValue(TRIAL_ID));
        }
    }, [protocol, metadata]);
    
    
    useEffect(() => {       
        if (!selectAllOnLoad || !currentDetails[listNode] || !currentDetails[listNode].value) return;

        //stop reloading forever
        // const [dataToAdd, dataToRemove] = getDataToAddAndRemove();

        // if (selectAllOnLoad && (dataToAdd.length !== currentDetails[listNode].value.length)) {
        //     updateStudyDetails(dataToAdd, dataToRemove, false, true);
        //     setSelectAllOnLoad(false);
        //     setListNode(null);
        // }
    }, [selectAllOnLoad, currentDetails, listNode]);

    useEffect(() => {        
        setSponsorValue(getValue(SPONSOR));
        setTrialValue(getValue(TRIAL_ID));
        const sponsorOverride = getOverriderLabel(SPONSOR.label);
        const trialIDOverride = getOverriderLabel(TRIAL_ID.label);
        const sponsorOverrideDescriptor = binderDescriptors.find(b => b.displayName === sponsorOverride);
        const trialIdOverrideDescriptor = binderDescriptors.find(b => b.displayName === trialIDOverride);

        const dataSourceOverrideLabelSponsor = dataSources.find(dataSource =>
            dataSource.name === sponsorOverride
        );
        const overrideNameInDataSourceSponsor = dataSourceOverrideLabelSponsor ? binderDescriptors.find(det =>
            det.dataSourceId && det.dataSourceId === dataSourceOverrideLabelSponsor.id
        ) : null;

        const dataSourceOverrideLabelTrialID = dataSources.find(dataSource =>
            dataSource.name === trialIDOverride
        );
        const overrideNameInDataSourceTrialId = dataSourceOverrideLabelTrialID ? binderDescriptors.find(det =>
            det.dataSourceId && det.dataSourceId === dataSourceOverrideLabelTrialID.id
        ) : null;


        const sponsorOverrideDescriptorName = sponsorOverrideDescriptor ? sponsorOverrideDescriptor.label : null;
        const trialIdOverrideDescriptorName = trialIdOverrideDescriptor ? trialIdOverrideDescriptor.label : null;

        const currentSponsor = metadata.filter(data => {
            if (data.name === sponsorOverride) {
                return data;
            } else if (data.name === SPONSOR.name) {
                return data;
            } else if (data.name === sponsorOverrideDescriptorName) {
                return data;
            } else if (data.name === (overrideNameInDataSourceSponsor && overrideNameInDataSourceSponsor.name)) {
                return data;
            }
        });
        const currentTrialID = metadata.filter(data => {
            if (data.name === trialIDOverride) {
                return data;
            } else if (data.name === TRIAL_ID.name) {
                return data;
            } else if (data.name === trialIdOverrideDescriptorName) {
                return data;
            } else if (data.name === (overrideNameInDataSourceTrialId && overrideNameInDataSourceTrialId.name)) {
                return data;
            }
        });

        const tempDetails = { ...currentDetails };
        const sponsorDescriptor = getBinderDetail(SPONSOR.label);
        if (currentSponsor.length > 1) {
            tempDetails.sponsorCro = {
                ...currentSponsor[0],
                value: currentSponsor,
            };
        } else {
            tempDetails.sponsorCro = currentSponsor[0];
        }

        const protocalDescriptor = getBinderDetail(TRIAL_ID.label);
        if (currentTrialID.some(trial => trial.inputFieldType === 'multi-select')) {
            tempDetails.trialId = {
                ...currentTrialID[0],
                value: currentTrialID,
            };
        } else {
            tempDetails.trialId = currentTrialID[0];
        }

        if (tempDetails.sponsorCro) {
            tempDetails.sponsorCro['descriptorId'] = sponsorDescriptor ? sponsorDescriptor.descriptorId : null;
        }

        if (tempDetails.trialId) {
            tempDetails.trialId['descriptorId'] = protocalDescriptor ? protocalDescriptor.descriptorId : null;
        }
        
        setCurrentDetails(tempDetails);
    }, [metadata,sponsor, protocol]);

    function getOverriderLabel(selector) {
        return `${datasourceOverrider(selector, selectedDatasourceOverrides, dataSources, selector)}`;
    }

    function getMetadataFromStudyDetails(detailName) {
        const normalizedDetailName = detailName.toLowerCase();

        const detail = binderDescriptors.find(det =>
            (det.displayName && det.displayName.toLowerCase() === normalizedDetailName) ||
            (det.label && det.label.toLowerCase() === normalizedDetailName)
        );

        // Find the data source override detail
        const dataSourceOverrideDetail = dataSources.find(dataSource =>
            dataSource.name.toLowerCase() === normalizedDetailName
        );

        // If data source override detail is found, use its ID to find the corresponding binder descriptor
        const dataSourceDetail = dataSourceOverrideDetail ? binderDescriptors.find(det =>
            det.dataSourceId && det.dataSourceId === dataSourceOverrideDetail.id
        ) : null;

        return detail || dataSourceDetail || null;

    }

    function getBinderDetail(selector) {
        const override = getOverride(selector, selectedDatasourceOverrides, dataSources);
        if (!override) return;
        const [descriptor] = binderDescriptors.filter(desc => desc.dataSourceId === override.id);

        return descriptor;
    }

    function buildCurrentDetails({ name, label }) {
        const inputFieldType = getInputType(label);
        const dataType = 'small_text';
        const type = isDocumentDrivingDetail(label) ? 'binder' : 'essentials';
        const binderDetail = getBinderDetail(label);

        return {
            inputFieldType,
            dataType,
            type,
            institutionId,
            name,
            descriptorId: binderDetail ? binderDetail.descriptorId : null
        };
    }


    function getInputType(selector) {
        const override = getOverride(selector, selectedDatasourceOverrides, dataSources);
        if (!override) return 'single-select';

        const [detail] = studyDetails.filter(detail => detail.dataSourceId === override.id);


        return detail ? detail.inputFieldType : 'single-select';
    }

    function isDocumentDrivingDetail(selector) {
        const override = getOverride(selector, selectedDatasourceOverrides, dataSources);
        if (!override) return;

        const [detail] = binderDescriptors.filter(detail => detail.dataSourceId === override.id);

        return !!detail;
    }

    function getValue(field) {
        let val = '';
        const stateProp = field.name === TRIAL_ID.name ? protocol : sponsor;
        const _override = getOverride(field.label, selectedDatasourceOverrides, dataSources);

        if (!_override || !stateProp.isStudyDetails) {
            const [value] = metadata.filter(data => data.name === field.name);
            return value ? value.value : '';
        }

        const [binderDetail] = binderDescriptors.filter(detail => detail.dataSourceId === _override.id);

        if (!binderDetail) return;
        const value = metadata.filter(data => data.descriptorId === binderDetail.descriptorId);

        if (value.some(val => val.inputFieldType === 'multi-select')) {
            val = value.map(el => ({ ...el, label: el.value }));
        } else if (value && !isEmpty(value)) {
            val = value[0].value;
        } else {
            val = binder[field.binderLevelSelector];
        }

        return val;
    }

    function updateStudyDetails(dataToAdd, dataToRemove, notify = true, fetchStudy = true) {
        const studyUpdatedData = {
            name: studyName,
            institutionId,
            id,
            binderId: binder.id,
            studyTypeId: studyType.id,
            eventsTabEnabled: eventsTabEnable,
            delegationOfAuthorityEnabled: doaEnabled,
            isMissingDetail
        };
        let billable = binder.billable;
        if (!billable && (currentStageValue.value === 'Open to Accrual' || currentStageValue.value === 'Maintenance')) {
            const binderTemplate = binderTemplates.find(template => template.id === binder.binderTemplateId);
            binderTemplate && binderTemplate.billable === true ? billable = true : billable = false;
        }

        if (currentStageValue.isBillable !== currentStage.isBillable && binder.billable !== billable) {
            recordBinderBillableHistory(billable, id);
        }

        return updateStudy(studyUpdatedData, currentStageValue.id, dataToAdd, dataToRemove, notify, fetchStudy, billable);
    }

    function getDataToAddAndRemove() {
        const metadataToRemove = [];
        const metadataToAdd = [];

        if (!isEmpty(updateDetails.sponsorCro)) {

            if (isArray(updateDetails.sponsorCro)) {
                updateDetails.sponsorCro.forEach(el => {
                    metadataToAdd.push(el);
                });
            } else {
                metadataToAdd.push(updateDetails.sponsorCro);
            }
        }

        if (currentDetails.sponsorCro && !isEmpty(currentDetails.sponsorCro) && isUpdated.sponsorCro) {
            if (Object.prototype.hasOwnProperty.call(currentDetails.sponsorCro, 'value') && isArray(currentDetails.sponsorCro.value)) {
                currentDetails.sponsorCro.value.forEach(el => {
                    metadataToRemove.push(el);
                });
            } else {
                metadataToRemove.push(currentDetails.sponsorCro);
            }
        }

        if (!isEmpty(updateDetails.trialId)) {
            if (isArray(updateDetails.trialId)) {
                updateDetails.trialId.forEach(el => {
                    metadataToAdd.push(el);
                });
            } else {
                metadataToAdd.push(updateDetails.trialId);
            }
        }

        if (currentDetails.trialId && !isEmpty(currentDetails.trialId) && isUpdated.trialId) {
            if (Object.prototype.hasOwnProperty.call(currentDetails.trialId, 'value') && isArray(currentDetails.trialId.value)) {
                currentDetails.trialId.value.forEach(el => {
                    metadataToRemove.push(el);
                });
            } else {
                metadataToRemove.push(currentDetails.trialId);
            }
        }

        metadataToAdd.map(meta => {
            if (!meta) return;
            delete meta.id;
            delete meta.studyId;
            delete meta.label;
            delete meta.shouldBeAllValuesSelected;
            delete meta.displayName;
            delete meta.chipData;
            delete meta.dataSourceId;
        });
        metadataToRemove.map(meta => {
            if (!meta) return;
            delete meta.label;
        });

        return [metadataToAdd, metadataToRemove];
    }

    function saveUpdates() {
        if (!validateEmptyFields()) return;
        const [metadataToAdd, metadataToRemove] = getDataToAddAndRemove();
        updateStudyDetails(metadataToAdd, metadataToRemove);
    }

    function validateEmptyFields() {
        const { sponsor, trialId, binderName } = isDetailEmpty;
        return !sponsor && !trialId && !binderName;
    }

    function handleDetailsOnChange(field, value, stateProp) {
        const { name, label } = field;
        const isMultiSelecte = stateProp.inputFieldType === 'multi-select';
        const currentDetail = currentDetails[name] || buildCurrentDetails(field);
        let updatedState = {
            ...currentDetail,
            value: `${value.value ? value.value : value}`
        };

        if (isMultiSelecte) {
            const override = getOverriderLabel(label);
            const metaDescription = getMetadataFromStudyDetails(override);
            delete metaDescription.instructions;
            metaDescription.type = currentDetail.type;

            if (isEmpty(value)) {
                setIsDetailEmpty({
                    ...isDetailEmpty,
                    [name]: true
                });
            } else {
                setIsDetailEmpty({
                    ...isDetailEmpty,
                    [name]: false
                });
            }
            updatedState = value.map(val => {
                return {
                    ...metaDescription,
                    value: String(val.value)
                };
            });
        }

        setIsUpdated({
            ...isUpdated,
            [name]: true
        });

        setUpdatedDetails({ ...updateDetails, [name]: updatedState });
        if (stateProp.shouldBeAllValuesSelected) {
            setSelectAllOnLoad(true);
            setListNode(name);
        }
    }

    function handleBinderNameChanged(value) {
        if (!value) {
            setIsDetailEmpty({
                ...isDetailEmpty,
                binderName: true,
            });
            return;
        }

        setIsDetailEmpty({
            ...isDetailEmpty,
            binderName: false,
        });

        setStudyName(value);
    }

    const customStylesV2WithPlaceholder = {
        ...customStylesV2,
        singleValue: (provided, state) => {
            const color = '#28282E';
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';
            return {
                ...provided, color, opacity, transition, padding: 0,
                fontWeight: '400',
                fontStyle: 'normal',
                fontFamily: 'Hind',
                'line-height': '20px',
                paddingTop: '4px'
            };
        },
        placeholder: (provided) => ({
            ...provided,
            fontFamily: 'Hind !important',
            fontSize: '16px !important',
            fontWeight: '400 !important',
            lineHeight: '23.59px !important',
            fontStyle: 'italic !important',
            color: '#B1B1B1 !important',
            paddingTop: '4px'
        })
    };

    if (isEmpty(sponsor) || isEmpty(protocol)) {
        return <LoadingComponent />;
    }
    function updateStudyStage(newStudyStage) {

        const { value: newStudyStageValue } = newStudyStage;
        const { value: currentStudyStageValue } = currentStage;

        const _currentStage = currentStudyStageValue === 'Study Start-Up' || currentStudyStageValue === 'Pending Approval';
        const newStage = newStudyStageValue === 'Maintenance' || newStudyStageValue === 'Open to Accrual';

        if (_currentStage && newStage) {
            const binderTemplate = binderTemplates.find(template => template.id === binder.binderTemplateId);
            if (binderTemplate && binderTemplate.billable) {
                setStudyStageChangeWaningMessage({
                    billable: true,
                    message: BILLABE_TEMPLATE_MESSAGE.replace('_stage_', newStudyStageValue)
                });
            } else if (binderTemplate && !binderTemplate.billable) {
                setStudyStageChangeWaningMessage({
                    billable: false,
                    message: NON_BILLABLE_TEMPLATE_MESSAGE.replace('_stage_', newStudyStageValue)
                });
            }
        } else {
            setStudyStageChangeWaningMessage({
                billable: false,
                message: ''
            });
        }

        setCurrentStageValue(newStudyStage);
    }

    return (
        <div className={styles.StudySettingsBasicInformation}>
            <PageTitle>Basic Information</PageTitle>
            <p className={styles.label}>Binder URL</p>
            <CopyLink type='study' useBinderV4={true} id={id} />

            {
                sponsor && protocol && (
                    <Fragment>
                        <MultiSelect
                            label={sponsor.label || SPONSOR.label}
                            placeholder={sponsor.placeholder || `Select ${SPONSOR.label}`}
                            Tooltip={sponsor.isStudyDetails && DocumentDrivingDetailIcon}
                            options={sponsor.options || []}
                            isReadOnly={!canManageStudyMetadata}
                            value={getValue(SPONSOR)}
                            chipData={sponsorValue}
                            onSelectedOption={value => handleDetailsOnChange(SPONSOR, value, sponsor)}
                            onChange={value => handleDetailsOnChange(SPONSOR, value, sponsor)}
                            isSearchable={true}
                            isRequired={isStudyBinder}
                            canAddDataSource={canAddDataSource}
                            type={sponsor.inputFieldType}
                            showCreateField={sponsor.showCreateField}
                            listWidth={'700px'}
                            datasourceId={sponsor.dataSourceId}
                            isStepOne={true}
                            isEmptyError={isDetailEmpty.sponsorCro}
                            shouldBeAllValuesSelected={sponsor.shouldBeAllValuesSelected}
                            instructions={sponsor.instructions}
                        />
                        {isDetailEmpty.sponsorCro && isStudyBinder && (<ErrorMessage text={getOverriderLabel(SPONSOR.label)} />)}

                        <MultiSelect
                            label={protocol.label || TRIAL_ID.label}
                            placeholder={protocol.placeholder || `Select ${TRIAL_ID.label}`}
                            options={protocol.options || []}
                            Tooltip={protocol.isStudyDetails && DocumentDrivingDetailIcon}
                            isReadOnly={!canManageStudyMetadata}
                            value={getValue(TRIAL_ID)}
                            chipData={trialValue}
                            onSelectedOption={value => handleDetailsOnChange(TRIAL_ID, value, protocol)}
                            onChange={value => handleDetailsOnChange(TRIAL_ID, value, protocol)}
                            isSearchable={true}
                            isRequired={isStudyBinder}
                            canAddDataSource={canAddDataSource}
                            type={protocol.inputFieldType}
                            showCreateField={protocol.showCreateField}
                            listWidth={'700px'}
                            datasourceId={protocol.dataSourceId}
                            isEmptyError={isDetailEmpty.trialId}
                            isStepOne={true}
                            shouldBeAllValuesSelected={protocol.shouldBeAllValuesSelected}
                            instructions={protocol.instructions}
                        />

                        {isDetailEmpty.trialId && isStudyBinder && (<ErrorMessage text={getOverriderLabel(TRIAL_ID.label)} />)}
                    </Fragment>
                )
            }


            <FlatInput
                label="Binder Name"
                placeholder="Enter Binder Name"
                value={studyName}
                isRequired={true}
                onChange={handleBinderNameChanged}
                notValid={isDetailEmpty.binderName}
                isReadOnly={!canManageStudyMetadata}
            />
            {isDetailEmpty.binderName && (<ErrorMessage text={'Binder Name'} />)}

            <InputField
                required={true}
                label='Study Stage '
                htmlFor='studyStage'
                customClasses={{
                    inputWrapper: styles.inputWrapper
                }}
            >
                {canManageStudyMetadata ? <Select
                    id='studyStage'
                    name='studyStage'
                    placeholder="Select Study Stage"
                    options={studyStages}
                    data-cy="add-binder-study-stage"
                    styles={customStylesV2WithPlaceholder}
                    value={currentStageValue}
                    onChange={updateStudyStage}
                    components={{
                        DropdownIndicator: () => <ChevronIcon isOpen={Boolean(false)} customStyles={{ padding: '4px', paddingRight: '8px' }} />
                    }}
                /> :
                    <div>{currentStageValue.label}</div>}
            </InputField>
            {
                studyStageChangeWaningMessage.message && (
                    <div className={styles.Note}>
                        {studyStageChangeWaningMessage.billable ? <FontAwesomeIcon className={styles.dollarIcon} icon={faDollarSign} /> : <FontAwesomeIcon icon={faCircleInfo} />}
                        <p>{studyStageChangeWaningMessage.message}</p>
                    </div>
                )
            }
            <div className={styles.createdBy}>
                <p style={{ fontWeight: '500', color: '#222222' }}>Created by</p>
                <p style={{ fontWeight: '400' }}>{createdByUser && createdByUser.displayName}</p>
            </div>

            <div className={styles.delegationOfAuthorityContainer}>
                <p>
                    <label className={styles.delegationOfAuthorityCheckboxLabel}>
                        <input
                            type="checkbox"
                            checked={eventsTabEnable}
                            className={styles.delegationOfAuthorityCheckbox}
                            onChange={({ target }) => setEventsEnabled(target.checked)}
                            disabled={!canManageStudyMetadata}
                        />
                        Turn on Events
                    </label>
                </p>
            </div>
            <div className={styles.delegationOfAuthorityContainer}>
                <p>
                    <label className={styles.delegationOfAuthorityCheckboxLabel}>
                        <input
                            type="checkbox"
                            checked={doaEnabled}
                            className={styles.delegationOfAuthorityCheckbox}
                            onChange={({ target }) => setDoaEnabled(target.checked)}
                            disabled={!canManageStudyMetadata}
                        />
                        Turn on Delegation Of Authority
                    </label>
                </p>
            </div>

            {canManageStudyMetadata && <SaveFixedFooter
                onClick={saveUpdates}
                data-cy="StudySettingsEssentials-onSubmit"
            >
                Save Changes
            </SaveFixedFooter>}
        </div>
    );
}

export default connect(
    (state, props) => {
        const {
            delegationOfAuthorityEnabled,
            eventsTabEnabled,
            createdByUser,
            id,
            metadata,
            currentStage,
            name,
            studyType
        } = state.study;

        const binderDescriptors = get(state, 'studySettings.binderDescriptors', []);
        const institutionId = get(state, 'me.institution.id');
        const binder = get(state, 'binder');
        const canAddDataSource = get(state, `me.institutionPermissions.${institutionId}.dataSources`, false);
        const canManageStudyMetadata = manageStudyMetadataPredicate(state);
        const isMissingDetail = get(state, 'study.isMissingDetail');
        const _studyStages = map(get(state, 'study.studyStages', []), (stage) => ({ ...stage, value: stage.name, label: stage.name }));
        const currentStageWithValue = { ...currentStage, value: currentStage && currentStage.name ? currentStage.name : '', label: currentStage && currentStage.name ? currentStage.name : '', isBillable: billbleLifeCycleStages.includes(currentStage.name) };
        const selectedBinderType = get(state, 'study.studyType', null);
        const isStudyBinder = selectedBinderType && selectedBinderType.category === 'study_binder';
        const binderTemplates = get(state, 'me.binderTemplates', []);

        const studyStages = _studyStages.map(stage => {
            return {
                ...stage,
                isBillable: billbleLifeCycleStages.includes(stage.name)
            };
        });

        return {
            delegationOfAuthorityEnabled,
            eventsTabEnabled,
            createdByUser,
            id,
            metadata,
            studyMeta: get(state, 'studySettings.metadata', []),
            currentStage: currentStageWithValue,
            studyStages,
            name,
            institutionId,
            canAddDataSource,
            canManageStudyMetadata,
            dataSources: filter(state.dataSources, ['institutionId', institutionId]),
            selectedDatasourceOverrides: get(state, 'selectedDatasourceOverrides', []),
            studyDetails: get(state, 'study.studyDetails', []),
            binder,
            studyType,
            binderDescriptors,
            isMissingDetail,
            isStudyBinder,
            binderTemplates
        };
    }, {
        updateStudy,
        recordBinderBillableHistory
    })(BasicInformation);
